(function() {
    'use strict';
    
a3_pilot_reports.controller('PassengerCtrl',PassengerCtrl)
 

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name PassengerCtrl
    * @description 
    *  Manages the passenger information view
    * @ngInject
    */
function PassengerCtrl(passenger,arrival,$scope,$uibModalInstance){
		$scope.passenger = passenger;
		$scope.arrival = arrival;
		$scope.cancel = cancel;
		$scope.IsOld = IsOld;

        /**
         * Checks if the data are new
         * @memberof PassengerCtrl
         * @param {string} time timestamp
         * @return {boolean} IsOld
         */
		function IsOld(time){
			IsOld=false;
			if(time){
				var now = new Date();
				var timeDate = new Date(time);
				var diff =  now.getTime() - timeDate.getTime();
				if(diff>3600000){
					IsOld=true;
				}
			}
			return IsOld;
		}

        /**
         * Close the modal
         * @memberof PassengerCtrl
         */
		function cancel() {
			$uibModalInstance.dismiss('');
		}
	}

})();